export default "__VITE_ASSET__CRiee7z0__"